export default "__VITE_ASSET__DoEym8XP__"